import { render, staticRenderFns } from "./weeklyTable.vue?vue&type=template&id=93b6ebee&scoped=true&"
import script from "./weeklyTable.vue?vue&type=script&lang=js&"
export * from "./weeklyTable.vue?vue&type=script&lang=js&"
import style0 from "./weeklyTable.vue?vue&type=style&index=0&id=93b6ebee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b6ebee",
  null
  
)

export default component.exports